import CommonDelete from "@/components/common/Delete"
import { singleProp } from "@/interface/dataInterface"
import { FC } from "react"

const InventoryDelete: FC<singleProp> = ({prop}) => {
    return (
        <CommonDelete id={prop} resource="auto-service-inventory"/>
    )
}

export default InventoryDelete